import { render, staticRenderFns } from "./HeaderDesktopIcons.vue?vue&type=template&id=a4c06732&scoped=true"
import script from "./HeaderDesktopIcons.vue?vue&type=script&lang=ts"
export * from "./HeaderDesktopIcons.vue?vue&type=script&lang=ts"
import style0 from "./HeaderDesktopIcons.vue?vue&type=style&index=0&id=a4c06732&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c06732",
  null
  
)

export default component.exports